import { gql } from '@apollo/client';

import { CourseProfessor } from '../../types';
import { courseProfessorFragment } from '../fragments';

export interface AddProfessorToCourseMutationVariables {
  courseId: string;
  input: { professor: string };
}

export interface AddProfessorToCourseMutationResult {
  courseProfessor: CourseProfessor;
}

export const addProfessorToCourseMutation = gql`
  mutation AddProfessorToCourseMutation($courseId: String!, $input: AddProfessorToCourseMutationInput!) {
    courseProfessor(courseId: $courseId, input: $input) @rest(type: "CourseProfessor", path: "courses/{args.courseId}/professors", method: "POST") {
      ...CourseProfessor
    }
  }
  ${courseProfessorFragment}
`;
